<template>
  <div class="container pr advantage-box">

    <div class="advantage ">
      <div class="advantage-top">
        <div class="weclome">
          <div class="weclome-img">
            <router-link to="baseInfo">
              <img src="../../assets/default-icon.png" ng-src="" alt="">
            </router-link>
          </div>
          <div class="weclome-text">HI～欢迎来到天正商城</div>
          <div class="weclome-button">
            <router-link to="baseInfo" class="draft1"><span>查看权益</span></router-link>
            <!--  					<a class="draft2" target="_blank" v-if="false"><span>升级企业用户</span></a>-->
          </div>
        </div>
        <div class="login">
          <div class="login-name-order ">
            <router-link :to="orderRoute(5)" class="login-name-text" aria-label="我的订单-待确认">
              <div class="num">{{ orderCount.toBeConfirmed }}</div>
              <div>待确认</div>
            </router-link>
            <router-link :to="orderRoute(1)" class="login-name-text" aria-label="我的订单-待发货">
              <div class="num ">{{ orderCount.unshippedCount }}</div>
              <div>待发货</div>
            </router-link>
            <router-link :to="orderRoute(2)" class="login-name-text" aria-label="我的订单-待收货">
              <div class="num ">{{ orderCount.receivedCount }}</div>
              <div>待收货</div>
            </router-link>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="logo-img">
        <router-link
          v-if="showCoupon || isIntegralUser"
          :to="isIntegralUser ? '/score' : '/coupons'"
          class="small-logo small-logo-one"
        >
          {{ isIntegralUser ? '积分商城' : '领券中心' }}
          <div class="my-icon my-icon-logo-img my-icon-logo-img-xycj"></div>
        </router-link>
        <router-link v-if="showAddress" to="/address" class="small-logo small-logo-one">
          收货地址
          <div class="my-icon my-icon-logo-img my-icon-logo-img-zxzb"></div>
        </router-link>
        <!--  			<a href="#" class="small-logo small-logo-one mgb0">消息<div-->
        <!--  					class="my-icon my-icon-logo-img my-icon-logo-img-jfcx"></div>-->
        <!--        </a>-->
<!--        <a href="#" class="small-logo small-logo-one mgb0 " style="left: -50px;margin-top: 20px">积分查询-->
<!--          <div-->
<!--              class=" my-icon my-icon-logo-img my-icon-logo-img-mrqd">-->

<!--          </div>-->
<!--        </a>-->
<!--        <a href="#" class="small-logo small-logo-one" v-if="false">幸运抽奖-->
<!--          <div-->
<!--              class="my-icon my-icon-logo-img my-icon-logo-img-xycj"></div>-->
<!--        </a>-->
<!--        <a href="#" class="small-logo small-logo-one" v-if="false">在线直播-->
<!--          <div-->
<!--              class="my-icon my-icon-logo-img my-icon-logo-img-zxzb"></div>-->
<!--        </a>-->
<!--        <a href="javascript:void(0)" class="small-logo small-logo-one mgb0 " v-if="false">-->
<!--          每日签到-->
<!--          <div class=" my-icon my-icon-logo-img my-icon-logo-img-mrqd"></div>-->
<!--        </a>-->
        <div class="line"></div>
      </div>
           <div class="content" v-if="message.length>0">
              <ul class="notice fc-bet">
                <li class="active">信息公告</li>
              </ul>
              <div class="inner active " v-for="(item , index) in message" :key="index">
                <div class="message" v-html="item.title"></div>
              </div>
            </div>
      <!--  		<div class="content" >
              <ul class="notice fc-bet">
                <li class="active">存货专区公告</li>
                <li class="more"><a href="#">更多</a></li>
              </ul>
              <div class="inner active ">
                <a class="li" href="#"  :key="index">CDWC 存货100件</a>
                <a class="li" href="#"  :key="index">CDWC2 存货10件</a>
                <a class="li" href="#"  :key="index">X34 存货20件</a>
              </div>
            </div>-->
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderList } from '@/api/order'
import { getOrderStatistics, queryMessage } from '@/api/home'

export default {
  name: 'index-banner-right',
  data () {
    return {
      orderCount: {
        toBeConfirmed: 0,
        unshippedCount: 0,
        receivedCount: 0
      },
      message: [],
      queryParams: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    currentUser () {
      const storeUser = this.userInfo || {}
      if (storeUser && (storeUser.uid || storeUser.id || storeUser.loginName)) {
        return storeUser
      }
      const userInfo = sessionStorage.getItem('userInfo')
      if (!userInfo) return {}
      try {
        return JSON.parse(userInfo)
      } catch (error) {
        return {}
      }
    },
    isLoggedIn () {
      const user = this.currentUser
      return Boolean(user && (user.uid || user.id || user.loginName))
    },
    isIntegralUser () {
      return this.isLoggedIn && Number(this.currentUser.dealerLevel) === 1
    },
    showCoupon () {
      return !this.isLoggedIn || Number(this.currentUser.dealerLevel) === 2
    },
    showAddress () {
      if (!this.isLoggedIn) return true
      const user = this.currentUser
      const distributor = user.distributor || user
      const loginName = distributor.loginName
      if (Number(user.dealerLevel) === 2) return Boolean(distributor)
      return Number(user.dealerLevel) === 1 && Boolean(loginName) &&
        !loginName.startsWith('504639_') && !loginName.startsWith('139366_')
    }
  },
  watch: {
    userInfo: {
      deep: true,
      handler () {
        if (this.isLoggedIn) {
          this.queryOrderCountFun()
        } else {
          this.orderCount = {
            toBeConfirmed: 0,
            unshippedCount: 0,
            receivedCount: 0
          }
        }
      }
    }
  },
  created () {
    if (this.isLoggedIn) {
      this.queryOrderCountFun()
    }
    this.queryMessageFun()
  },
  methods: {
    orderRoute (type) {
      return {
        path: this.isIntegralUser ? '/integralOrders' : '/orders',
        query: { type }
      }
    },
    queryOrderCountFun () {
      if (this.isIntegralUser) {
        Promise.all([5, 1, 2].map(type => getOrderList({
          orderType: 1,
          type,
          page: 1,
          limit: 1
        }))).then(results => {
          this.orderCount = {
            toBeConfirmed: Number(results[0].total || 0),
            unshippedCount: Number(results[1].total || 0),
            receivedCount: Number(results[2].total || 0)
          }
        }).catch(error => {
          console.warn('积分订单统计加载失败', error)
        })
        return
      }
      getOrderStatistics(this.queryParams).then(res => {
        console.log('查询订单', res)
        this.orderCount = res.data || this.orderCount
      }).catch(error => {
        console.warn('订单统计加载失败', error)
      })
    },
    queryMessageFun () {
      queryMessage(this.queryParams).then(res => {
        this.message = res
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">

</style>
